import { render, staticRenderFns } from "./RoomItem.vue?vue&type=template&id=27c2d5a9&scoped=true"
import script from "./RoomItem.vue?vue&type=script&lang=js"
export * from "./RoomItem.vue?vue&type=script&lang=js"
import style0 from "./RoomItem.vue?vue&type=style&index=0&id=27c2d5a9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c2d5a9",
  null
  
)

export default component.exports